import { render } from "./PostItem.vue?vue&type=template&id=e1fadd40&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"

import "./PostItem.vue?vue&type=style&index=0&id=e1fadd40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fadd40"]])

export default __exports__